<template>
  <section
    class="plane-container"
    v-resize.initial:debounce="handleResize"
    :style="containerStyle"
  >
    <div
      ref="bgImgWrapper"
      class="plane__inner"
      :style="bgImgWrapperStyle"
      @mousemove="getCursorPosition($event)"
    >
      <!--      <div class="plane__logo">
        <img src="img/air_france_logo.png" alt="Air France logo" />
      </div>-->
      <img
        ref="bgImg"
        :style="bgImgStyle"
        class="plane__img"
        src="img/plane2.jpg"
        alt=""
      />
    </div>
    <seat
      class="seat"
      v-for="seat in seats"
      :title="seat.title"
      :key="seat.title"
      :styles="seat.style"
      :svg="seat.svg"
      :status="seat.status"
      :row="seat.row"
      :passenger="seat.passenger"
    >
    </seat>

    <div v-if="debug" class="coords">
      x: {{ cursor.x }}<br />
      y: {{ cursor.y }}<br />
      posX: {{ cursor.x / bgImgInitialSize.width }}<br />
      posY: {{ cursor.y / bgImgInitialSize.height }}
    </div>
  </section>
</template>

<script>
import resize from "vue-resize-directive"
import $ from "jquery"

import Seat from "./Seat"

export default {
  name: "Seats",
  directives: {
    resize
  },
  components: {
    Seat
  },
  props: {
    firstname: {
      type: String
    },
    invitations: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      bgImgInitialSize: {
        width: 2000,
        height: 1074
      },
      bgImgSize: {
        width: null,
        height: null,
        offset: {
          left: 0,
          top: 0
        },
        position: {
          top: 0
        },
        outerHeight: 0
      },
      bgImgScale: {
        x: 1,
        y: 1
      },
      bgImgStyle: {},
      bgImgWrapperStyle: {},
      containerStyle: {},
      seats: [
        {
          title: "seat-1",
          x: 0.602,
          y: 0.435,
          width: 0.11,
          height: 0.357,
          svg: {
            confirmed: "img/svg/4_confirmed.svg",
            awaiting: "img/svg/4_awaiting.svg",
            empty: "img/svg/4_empty.svg"
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-3",
          x: 0.187,
          y: 0.435,
          width: 0.115,
          height: 0.35,
          svg: {
            confirmed: "img/svg/1_confirmed.svg",
            awaiting: "img/svg/1_awaiting.svg",
            empty: "img/svg/1_empty.svg"
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-4",
          x: 0.718,
          y: 0.435,
          width: 0.11,
          height: 0.345,
          svg: {
            confirmed: "img/svg/5_confirmed.svg",
            awaiting: "img/svg/5_awaiting.svg",
            empty: "img/svg/5_empty.svg"
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-5",
          x: 0.069,
          y: 0.43,
          width: 0.115,
          height: 0.35,
          svg: {
            confirmed: "img/svg/3_confirmed.svg",
            awaiting: "img/svg/3_awaiting.svg",
            empty: "img/svg/3_empty.svg"
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-6",
          x: 0.826,
          y: 0.435,
          width: 0.117,
          height: 0.352,
          svg: {
            confirmed: "img/svg/6_confirmed.svg",
            awaiting: "img/svg/6_awaiting.svg",
            empty: "img/svg/6_empty.svg"
          },
          style: {},
          status: "empty",
          passenger: null,
          row: 1
        },
        {
          title: "seat-2",
          x: 0.308,
          y: 0.434,
          width: 0.113,
          height: 0.353,
          svg: {
            confirmed: "img/svg/planeowner.svg",
            awaiting: "img/svg/planeowner.svg",
            empty: "img/svg/planeowner.svg"
          },
          style: {},
          status: "confirmed",
          passenger: null,
          row: 1
        }
      ],
      debug: false,
      cursor: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    handleResize() {
      this.bgImgSize.width = $(this.$refs.bgImg).width()
      this.bgImgSize.height = $(this.$refs.bgImg).height()
      this.bgImgSize.offset.top = $(this.$refs.bgImg).offset().top
      this.bgImgSize.offset.left = $(this.$refs.bgImg).offset().left
    },
    getCursorPosition(evt) {
      if (!this.debug) return

      this.cursor = {
        x: Math.round(evt.clientX / this.bgImgScale.x),
        y: Math.round(
          evt.clientY / this.bgImgScale.y -
            this.bgImgSize.offset.top / this.bgImgScale.y
        )
      }
    }
  },
  watch: {
    bgImgSize: {
      handler(bgImg) {
        if (bgImg.height > $(window).height()) {
          this.bgImgStyle = { opacity: 1, position: "absolute", bottom: 0 }
          this.bgImgWrapperStyle = { height: "calc(100vh - 50px)" }
        } else {
          this.bgImgStyle = { opacity: 1 }
          this.bgImgWrapperStyle = { height: "auto" }
        }
        this.bgImgScale.x = bgImg.width / this.bgImgInitialSize.width
        this.bgImgScale.y = bgImg.height / this.bgImgInitialSize.height

        this.seats.forEach((seat, index) => {
          const x = bgImg.offset.left + seat.x * bgImg.width
          // const y = seat.y * bgImg.height /*+ (bgImg.offset.top - 50)*/
          const bottom = (1 - seat.y - seat.height) * bgImg.height

          const width = seat.width * bgImg.width
          const height = seat.height * bgImg.height

          this.seats[index].style = {
            left: x + "px",
            bottom: bottom + "px",
            width: width + "px",
            height: height + "px"
          }
        })
      },
      deep: true
    },
    invitations: {
      handler(invitations) {
        invitations.forEach((invitation, index) => {
          let status = "empty"
          if (invitation.isAccepted) {
            status = "confirmed"
          } else if (invitation.createdAt) {
            status = "awaiting"
          }
          this.seats[index].status = status
          this.seats[index].passenger = invitation.recipientFirstname
        })
      },
      deep: true,
      immediate: true
    },
    firstname: {
      handler(firstname) {
        this.seats[5].passenger = firstname
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.plane-container {
}

.plane__inner {
  margin: 0 auto;
  position: relative;
  background-color: whitesmoke;
}

.plane__img {
  display: block;
  opacity: 0;
  width: 100%;
  transition: opacity 0.3s;
}

.plane__logo {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 15%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1;

  > img {
    display: block;
    width: 80%;
    max-width: 500px;
    max-height: 90%;
  }
}

.coords {
  position: absolute;
  top: 50px;
  left: 50px;
  padding: 5px 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
